import type { QueryClient } from '@tanstack/react-query';

const invalidate = (queryClient: QueryClient, queryKey: readonly unknown[]) =>
  queryClient.invalidateQueries({ queryKey });

export const invalidateDashboardData = (queryClient: QueryClient) =>
  Promise.all([
    invalidate(queryClient, ['dashboard-stats']),
  ]);

export const invalidateMediaData = (queryClient: QueryClient) =>
  Promise.all([
    invalidate(queryClient, ['media']),
    invalidate(queryClient, ['media-for-device']),
    invalidateDashboardData(queryClient),
  ]);

export const invalidatePlaylistData = (queryClient: QueryClient) =>
  Promise.all([
    invalidate(queryClient, ['playlists']),
    invalidate(queryClient, ['playlists-for-device']),
    invalidateDashboardData(queryClient),
  ]);

export const invalidateScheduleData = (queryClient: QueryClient) =>
  Promise.all([
    invalidate(queryClient, ['schedules']),
    invalidate(queryClient, ['schedule-stats']),
    invalidate(queryClient, ['calendarEvents']),
    invalidate(queryClient, ['scheduleWithEvents']),
    invalidateDashboardData(queryClient),
  ]);

export const invalidateDeviceData = (queryClient: QueryClient) =>
  Promise.all([
    invalidate(queryClient, ['devices']),
    invalidate(queryClient, ['devices-map']),
    invalidate(queryClient, ['devices-for-api-keys']),
    invalidate(queryClient, ['device']),
    invalidate(queryClient, ['device-stats']),
    invalidate(queryClient, ['device-latest']),
    invalidateDashboardData(queryClient),
  ]);

export const invalidateRegistrationData = (queryClient: QueryClient) =>
  Promise.all([
    invalidate(queryClient, ['registrationTokens']),
    invalidateDeviceData(queryClient),
  ]);

export const invalidateDeviceApiKeyData = (queryClient: QueryClient, deviceId?: number) =>
  Promise.all([
    invalidate(queryClient, deviceId ? ['deviceApiKeys', deviceId] : ['deviceApiKeys']),
    invalidate(queryClient, deviceId ? ['deviceApiKeyStats', deviceId] : ['deviceApiKeyStats']),
    invalidateDeviceData(queryClient),
  ]);

export const invalidateWebPlayerData = (queryClient: QueryClient) =>
  Promise.all([
    invalidate(queryClient, ['web-players']),
    invalidateDeviceData(queryClient),
  ]);

export const invalidateUserData = (queryClient: QueryClient) =>
  Promise.all([
    invalidate(queryClient, ['users']),
    invalidate(queryClient, ['user-stats']),
    invalidate(queryClient, ['user-activity']),
    invalidateDashboardData(queryClient),
  ]);

export const invalidateAdminData = (queryClient: QueryClient) =>
  Promise.all([
    invalidateMediaData(queryClient),
    invalidatePlaylistData(queryClient),
    invalidateScheduleData(queryClient),
    invalidateDeviceData(queryClient),
    invalidateRegistrationData(queryClient),
    invalidateDeviceApiKeyData(queryClient),
    invalidateWebPlayerData(queryClient),
    invalidateUserData(queryClient),
  ]);
